import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgrupamentosService } from 'src/app/service/agrupamentos.service';
import { AlertService } from 'src/app/service/alert.service';
import { ClientesService } from 'src/app/service/clientes.service';
import { UsuariosService } from 'src/app/service/usuarios.service';

@Component({
  selector: 'app-atualizar-agrupamento',
  templateUrl: './atualizar-agrupamento.component.html',
  styleUrls: ['./atualizar-agrupamento.component.css']
})
export class AtualizarAgrupamentoComponent implements OnInit {

  etapa = 1;
  loader = false;
  clientes = [] as any;
  produtos = [] as any;
  usuarios = [] as any;
  usuariosVinculadoAoAgrupamento = [] as any;
  clientesVinculadoAoAgrupamento = [] as any;
  tiposAgrupamentos = [] as any;
  form = this.formBuilder.group({
    vc_nome: new FormControl('', [Validators.required]),
    fk_tipo_agrupamento: new FormControl('', [Validators.required]),
    fk_produto: new FormControl('', [Validators.required]),
    ar_usuarios: new FormControl([], [Validators.required]),
    ar_clientes: new FormControl([], [Validators.required]),
  })
  exibirUsuario = false
  exibirCliente = false
  exibirDadosSelecionados = false;

  agrupamentoId: any
  agrupamento = [] as any
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private agrupamentoService: AgrupamentosService,
    private usuarioService: UsuariosService,
    private clientesService: ClientesService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.agrupamentoId = this.activatedRoute.snapshot.paramMap.get('id')!
    this.listarAgrupamento(parseInt(this.agrupamentoId))
  }

  listarAgrupamento(idAgrupamento: number){
    this.agrupamentoService.listaAgrupamentoPorId(idAgrupamento).subscribe((resp:any) => {
      if (Object.keys(resp).length !== 0){
        this.agrupamento = resp
        this.produtos.push(this.agrupamento.produto)
        this.tiposAgrupamentos.push(this.agrupamento.tipo_agrupamento)
        this.form.get('vc_nome')?.setValue(this.agrupamento.vc_nome)
        this.form.get('fk_tipo_agrupamento')?.setValue(this.agrupamento.tipo_agrupamento.sr_id)
        this.form.get('fk_produto')?.setValue(this.agrupamento.produto.sr_id)
        this.usuariosVinculadoAoAgrupamento = resp.agrupamento_usuarios
        this.clientesVinculadoAoAgrupamento = resp.agrupamento_clientes
        this.exibirUsuario = true
        this.buscarUsuarios()
      }
    })
  }

  buscarUsuarios() {
    this.loader = true;
    this.usuarioService.listarUsuariosAgrupamentos().subscribe((resp: any) => {
      this.usuarios = resp
      this.loader = false;
    }, error => {
      this.loader = false;
      this.redirecionaComErro("Não foi possível encontrar os usuários.");
    })
  }

  listarClientes() {
    this.loader = true
    let usuariosString = this.form.get('ar_usuarios')?.value.join(",")
    this.clientesService.listarClientesEmComumEntreUsuarios(usuariosString).subscribe((resp: any) => {
      this.exibirCliente = true
      this.loader = false
      this.clientes = resp
    }, err => {
      this.loader = false
      this.redirecionaComErro("Não foi possível encontrar os clientes.");
    })
  }

  atualizar() {
    this.agrupamentoService.atualizarAgrupamento(this.form.value, this.agrupamentoId).subscribe((resp: any) => {
      this.alertService.success(resp.mensagem);
      this.router.navigate(['configuracao/agrupamentos']);
    })
  }

  cancel() {
    this.router.navigate(['configuracao/agrupamentos']);
  }

  receberCliente(valor: any) {
    const arrayIdUsuarios = valor.map((cliente: any) => {
      return cliente.sr_id
    })
    this.clientes = valor;
    this.form.get('ar_clientes')?.setValue(arrayIdUsuarios);
    this.exibirCliente = false;
    this.exibirDadosSelecionados = true;
  }

  receberUsuarios(valor: any) {
    const arrayIdUsuarios = valor.map((usuario: any) => {
      return usuario.sr_id
    })
    this.usuarios = valor;
    this.form.get('ar_usuarios')?.setValue(arrayIdUsuarios)
    this.exibirUsuario = false
    this.listarClientes()
  }

  redirecionaComErro(mensagem: string) {
    this.alertService.error(mensagem);
    this.router.navigate(['configuracao/agrupamentos']);
  }
  

}
